/**
 * @author Vibhor <vibhor.sharma@314ecorp.com>
 * @description React Hook useGetSecondaryPayers
 */
import { useQuery, UseQueryResult } from '@tanstack/react-query';

import api from 'client/index';
import QUERY_KEYS from 'app-constants/queryKeys';

/**
 * use get secondary payers hook
 * @returns {UseQueryResult} useGetSecondaryPayers
 */
const useGetSecondaryPayers = (id: string): UseQueryResult<ClaimRequest.ISecondaryClaimPayers[]> => {
	return useQuery({
		queryKey: [QUERY_KEYS.secondaryClaimPayers, { id }],
		queryFn: async () => {
			if (id) {
				const { data } = await api.FHIRClaimApi.getClaimCoverages({ claimId: id });
				return data;
			}
		},
		enabled: !!id,
	});
};

export default useGetSecondaryPayers;
